import "yage/schemas/index";
import "yage/console/preload";

import { GameCoordinator } from "yage/game/GameCoordinator";
import { initialize as initMysticMayhem } from "./projectv";
const coordinator = GameCoordinator.GetInstance();

initMysticMayhem(coordinator);
console.log("intialized");
